/** Canonical URL-backed sections for the project Admin workspace. */

export type ProjectAdminSection = 'project' | 'appointment' | 'contract' | 'payment' | 'dates' | 'activity';

export const PROJECT_ADMIN_SECTIONS: ReadonlyArray<{
  section: ProjectAdminSection;
  id: string;
  label: string;
  sfSymbol: string;
}> = [
  { section: 'project', id: 'admin', label: 'Project', sfSymbol: 'building.2' },
  { section: 'appointment', id: 'admin/appointment', label: 'Appointment & parties', sfSymbol: 'person.2' },
  { section: 'contract', id: 'admin/contract', label: 'Contract', sfSymbol: 'doc.text' },
  { section: 'payment', id: 'admin/payment', label: 'Payment', sfSymbol: 'sterlingsign.circle' },
  { section: 'dates', id: 'admin/dates', label: 'Dates', sfSymbol: 'calendar' },
  { section: 'activity', id: 'activity', label: 'Activity', sfSymbol: 'clock.arrow.circlepath' },
];

const ADMIN_SECTION_BY_TAB = new Map(
  PROJECT_ADMIN_SECTIONS.map((item) => [item.id, item.section]),
);

export function adminSectionFromProjectTab(tab: string | null | undefined): ProjectAdminSection | null {
  if (!tab) return null;
  return ADMIN_SECTION_BY_TAB.get(tab) ?? null;
}

export function isProjectAdminTab(tab: string | null | undefined): boolean {
  return adminSectionFromProjectTab(tab) !== null;
}

export interface ProjectAdminAccess {
  canManageTeam?: boolean;
  canViewFinancial?: boolean;
  canViewActivity?: boolean;
}

/**
 * Canvas sections the user may see, in order. `navigationIds` is the
 * workspace's resolved project rail (null when not authoritative); a grant on
 * the rail narrows what the capabilities alone would allow.
 */
export function visibleProjectAdminSections(
  access: ProjectAdminAccess | null | undefined,
  navigationIds?: ReadonlySet<string> | null,
): ProjectAdminSection[] {
  return PROJECT_ADMIN_SECTIONS.map((item) => item.section).filter((section) => {
    if (section === 'activity') {
      return access?.canViewActivity === true && (!navigationIds || navigationIds.has('activity'));
    }
    if (section === 'contract' || section === 'payment') {
      return access?.canViewFinancial === true
        && (!navigationIds || navigationIds.has('admin') || navigationIds.has('admin/contract'));
    }
    return access?.canManageTeam === true && (!navigationIds || navigationIds.has('admin'));
  });
}
